export default __webpack_public_path__ + "static/media/email.9d564696.svg";